import { useState } from 'react';
import { Stack } from '@mui/material';
import AttestationTable from './attestation-table';
import AttestationStatusCharts from './attestation-status-charts';

interface ManagedResourcesProps {
  data: {
    users: any[];
    systems: any[];
    departments: any[];
    cloudAccounts: any[];
    resources: any[];
    resourceGroups: any[];
    rejectedResources: any[];
  };
  onDataChange?: () => void;
}

function ManagedResources({ data, onDataChange }: ManagedResourcesProps) {
  const [groupBy, setGroupBy] = useState<'hierarchy' | 'systems'>('hierarchy');

  const handleGroupByChange = (newGroupBy: 'hierarchy' | 'systems') => {
    setGroupBy(newGroupBy);
  };

  return (
    <Stack spacing={2}>
      <AttestationStatusCharts
        display="managed"
        defaultChartScope="systems"
        data={data}
      />

      <AttestationTable
        groupBy={groupBy}
        onGroupByChange={handleGroupByChange}
        display="managed"
        data={data}
        onDataChange={onDataChange}
      />
    </Stack>
  );
}

export default ManagedResources;
